import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/common/Button";
import CustomAutoComplete from "../../../components/CustomAutoComplete";
import { MeetingTypes, RegionMeetingTypes } from "../../../contants";
import { SET_MEETING_TYPE } from "../../../redux/reducers/attendance";
import Styles from "../styles";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getCurrentYear, getPreviousMonth } from "../../../utils/dateAndTime";
import { selectAllSIUsers } from "../../../redux/selectors/user";

function ArchiveAttendanceForMobile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.auth?.userProfile?.data);
  const [meetinType, setMeetingType] = React.useState("");

  const { isRegionSi } = useSelector(selectAllSIUsers);

  const onClickForward = () => {
    navigate("/meetings/archive/view");
  };

  const onSelectMeeting = (selectedValue) => {
    setMeetingType(selectedValue?.value ?? "");
    dispatch({
      type: SET_MEETING_TYPE,
      payload: {
        type: selectedValue?.value ?? "",
      },
    });
  };

  useEffect(() => {
    setMeetingType(isRegionSi ? "CUBS_MEETING" : "DISCUSSION_MEETING");
    dispatch({
      type: SET_MEETING_TYPE,
      payload: {
        type: isRegionSi ? "CUBS_MEETING" : "DISCUSSION_MEETING",
      },
    });
  }, []);

  const isDistrictSI = Boolean(userProfile && userProfile.districtSi);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "0px 20px",
        minHeight: "900px",
        overflowY: "scroll",
      }}
    >
      <Grid item md={5} xs={5} sx={{ boxSizing: "border-box" }}>
        <Typography style={Styles.typography}>
          Organization Structure
        </Typography>
        <Grid container style={{ border: "1px solid #C4C4C4", padding: 20 }}>
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <Box sx={{ mb: "2rem" }}>
              <CustomAutoComplete
                required
                name="Area"
                label="Area"
                disabled
                options={[]}
                optionLabelId="name"
                optionValueId="structureId"
                selectedValue={() => {}}
                valueOnDisabled={userProfile?.areaName}
              />
            </Box>
            <Box sx={{ mb: "2rem" }}>
              <CustomAutoComplete
                required
                name="Cluster"
                label="Cluster"
                disabled
                options={[]}
                optionLabelId="name"
                optionValueId="structureId"
                selectedValue={() => {}}
                valueOnDisabled={userProfile?.clusterName}
              />
            </Box>
            <Box sx={{ mb: "2rem" }}>
              <CustomAutoComplete
                required
                name="Zone"
                label="10"
                disabled
                options={[]}
                optionLabelId="name"
                optionValueId="structureId"
                selectedValue={() => {}}
                valueOnDisabled={userProfile?.zoneName}
              />
            </Box>
            <Box sx={{ mb: "2rem" }}>
              <CustomAutoComplete
                required
                name="Region"
                label="Region"
                disabled
                options={[]}
                optionLabelId="name"
                optionValueId="structureId"
                selectedValue={() => {}}
                valueOnDisabled={userProfile?.regionName}
              />
            </Box>
            {!isRegionSi && (
              <>
                <Box sx={{ mb: "2rem" }}>
                  <CustomAutoComplete
                    required
                    name="Chapter"
                    label="Chapter"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.chapterName}
                  />
                </Box>
                <Box sx={{ mb: "2rem" }}>
                  <CustomAutoComplete
                    required
                    name="District"
                    label="District"
                    disabled
                    options={[]}
                    optionLabelId="name"
                    optionValueId="structureId"
                    selectedValue={() => {}}
                    valueOnDisabled={userProfile?.districtName}
                  />
                </Box>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={7} xs={7} sx={{ mt: "40px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pr: "30px",
          }}
        >
          <Box>
            <Typography
              varient="subtitle"
              sx={{
                fontWeight: "700",
                fontSize: "12px",
                color: "#8F92A1",
              }}
            >
              Month
            </Typography>
            <Typography
              varient="p"
              sx={{
                fontWeight: "500",
                fontSize: "16px",
                color: "#171717",
              }}
            >
              {getPreviousMonth()}
            </Typography>
          </Box>
          <Box>
            <Typography
              varient="subtitle"
              sx={{
                fontWeight: "700",
                fontSize: "12px",
                color: "#8F92A1",
              }}
            >
              Year
            </Typography>
            <Typography
              varient="p"
              sx={{
                fontWeight: "500",
                fontSize: "16px",
                color: "#171717",
              }}
            >
              {getCurrentYear()}
            </Typography>
          </Box>
          <Box sx={{ marginTop: "-5px", width: "50%" }}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.displayName}
              name="MeetingType"
              label="Meeting Type"
              options={isRegionSi ? RegionMeetingTypes : MeetingTypes}
              onChange={onSelectMeeting}
              value={meetinType}
              style={{ fontSize: "14px" }}
              disabled={!isDistrictSI && !isRegionSi}
              inputProps={{
                required: true,
                placeholder: "Select meeting Type",
              }}
            />
          </Box>
        </Box>
        <Grid container>
          <Grid item xs={12}>
            <Box
              style={{
                display: "flex",
                marginTop: "30px",
              }}
            >
              <Button
                variant="contained"
                label="VIew Attendance"
                onClick={onClickForward}
                disabled={!meetinType}
                style={
                  !meetinType
                    ? { opacity: ".5", width: "170px", pointerEvents: "none" }
                    : { width: "170px" }
                }
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ArchiveAttendanceForMobile;
